import React from 'react';
import {
  RedoIcon,
  RemoveAllIcon,
  RemoveElementIcon,
  UndoIcon,
  VisibilityIcon,
  VisibilityOffIcon
} from '../../imports/ui-parts';
import { tooltipMessages } from './tooltip-messages';

/* eslint-disable react/jsx-key */
export const mouseActions: [string | JSX.Element, string][] = [
  [
    '背景（またはバウンディングボックス内部）をクリックしてドラッグする',
    '新しいバウンディングボックスを描く'
  ],
  [
    'バウンディングボックスの頂点をクリックしてドラッグする',
    'バウンディングボックスをリサイズする'
  ],
  [
    'バウンディングボックスの辺をクリックしてドラッグする',
    'バウンディングボックスを移動する'
  ],
  ['ラベルボタンをクリック', 'ラベルを選択する'],
  ['マウススクロール', '画像をズームする'],
  ['マウス右ボタンでドラッグ（ズーム中）', 'ドラッグで画像を動かす'],
  // ['（スペースを押しているとき）画像上でドラッグする', '画像を移動する'],
  [<UndoIcon />, tooltipMessages.toolbar.undo],
  [<RedoIcon />, tooltipMessages.toolbar.redo],
  [<RemoveElementIcon />, '選択したバウンディングボックスを削除する'],
  [<RemoveAllIcon />, 'ページ内のバウンディングボックスをすべて削除する'],
  [<VisibilityIcon />, 'このラベルのバウンディングボックスを表示する'],
  [<VisibilityOffIcon />, 'このラベルのバウンディングボックスを表示しない'],
  [
    'アノテーション一覧の要素をクリックする',
    'バウンディングボックスの選択／非選択を切り替える'
  ]
];

export const keyboardActions: [string | JSX.Element, string][] = [
  ['1-9', 'ラベルを選択'],
  ['Delete', '選択したバウンディングボックスを削除する'],
  ['Ctrl + z', 'Undo'],
  ['Ctrl + Shift + z', 'Redo']
  // [<span>&larr;</span>, '前の画像に移る'],
  // [<span>&rarr;</span>, '次の画像に移る'],
  // ['space （押し続ける）', '（ズームした後で）マウスドラッグで画像を動かす']
];
